import ApiService from "./ApiService";
import appConfig from "configs/app.config";

export async function apiLoginUser(values) {
  // var formdata = new FormData();
  // formdata.append("email", values.email);
  // formdata.append("password", values.password);
  // formdata.append("role", "Super Admin");
  var requestOptions = {
    method: "POST",
    body: JSON.stringify({
      email: values.email,
      password: values.password,
      // role: "Panel User",
    }),
     headers: {
      "Content-Type": "application/json",
      Accept: "application/json", // <- important
    },
    credentials: 'include',
  };

  return fetch(appConfig.apiPrefix + "/login-by-otp", requestOptions);
}

export async function apiVerifyOtp(values) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json", // <- important
    },
    body: JSON.stringify({
      email: values.email,
      password: values.password,
      otp: values.otpCode,
    }),
    credentials: "include",
  };
  

  return fetch(
    appConfig.apiPrefix + `/otp-verify-login/${values.userId}`,
    requestOptions
  );
}
export async function apiResendOtp(values) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      email: values.email,
      role: "Super Admin",
    }),
    credentials: "include",
  };

  // ✅ use same endpoint as initial OTP send
  return fetch(appConfig.apiPrefix + "/register-login-by-otp", requestOptions);
}

